import {
  Scene,
  PlaneGeometry,
  ShadowMaterial,
  BufferGeometry,
  Material,
  Mesh,
  BackSide,
} from 'three'

export default function useRoom(_scene?: Scene) {
  let scene: Scene
  let geometry: PlaneGeometry
  let material: ShadowMaterial
  let mesh: Mesh<BufferGeometry, Material>

  if (_scene) {
    scene = _scene

    geometry = new PlaneGeometry(20, 20)
    material = new ShadowMaterial()
    material.side = BackSide
    material.opacity = 0.15

    mesh = new Mesh(geometry, material)
    mesh.receiveShadow = true
    mesh.position.y = 0
    mesh.rotateX(Math.PI / 2)

    mesh.name = 'room'

    scene.add(mesh)

    // const box = new BoxGeometry(1, 1, 1)
    // const boxMaterial = new MeshStandardMaterial({ color: '#f00' })
    // const boxMesh = new Mesh(box, boxMaterial)
    // boxMesh.position.set(0, 0.5, 0)
    // boxMesh.castShadow = true

    // scene.add(boxMesh)
  }
}
